import React from 'react';
import '../styles/NotFound.css'; // Import NotFound.css

import Header from '../../../shared/layout/Header';
import Footer from '../../../shared/layout/Footer';
import BottomFooter from '../../../shared/layout/BottomFooter';
import ScrollToTop from 'react-scroll-to-top';
import ColorInit from '../../../shared/layout/ColorInit';
import { CartProvider } from '../../cart/context/CartContext'; // Adjust the path if needed
import Seo from '../../../shared/ui/Seo';

const NotFound = () => {
  return (
    <CartProvider>
      <Seo title="Page Not Found" noindex />
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color="bigmall" />
      <Header />

      <div className="not-found-page">
        <div className="not-found-overlay">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>Want some goods or anything? Get back to home.</p>
          <a href="/" className="home-button">Back to Home</a>
        </div>
      </div>

      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default NotFound;
